import React from 'react'
import { Input, InputGroup,  } from 'reactstrap';

const filterMenuTree = (items, query) =>
    items.reduce((acc, item) => {
        if (!item) {
            return acc;
        }

        const matchesCurrentItem = item.name?.toLowerCase().includes(query);
        if (item.collapse && Array.isArray(item.views)) {
            const filteredViews = filterMenuTree(item.views, query);
            if (matchesCurrentItem || filteredViews.length) {
                acc.push({
                    ...item,
                    views: matchesCurrentItem ? item.views : filteredViews,
                });
            }
            return acc;
        }

        if (matchesCurrentItem) {
            acc.push(item);
        }
        return acc;
    }, []);

const BuscadorSideBar = ({traerMenu, setMenu, Menu}) => {
    
    const Buscar = (e)=>{
        let query = e.target.value.trim().toLowerCase()
        if (!query) {
            traerMenu()
            return;
        }

        let busqueda = filterMenuTree(Menu || [], query)
        if (busqueda) {
            setMenu(busqueda)
        }
    }
  return (
    <>
                <InputGroup>
                    <Input placeholder="Buscar" type="text" 
                        onChange={Buscar}
                        className="m-2"
                    />
                </InputGroup>
    </>
  )
}

export default BuscadorSideBar
